import { Editor } from '@tinymce/tinymce-react';

export function processNodeChange(wrapper: Element, editor: Editor) {
    if (wrapper?.tagName.toLowerCase() === 'div') {
        let lastMovedChild: Node = null;

        if (wrapper.classList.contains('table-responsive')) {
            lastMovedChild = cleanResponsiveWrapper(wrapper, ['table']);
        } else if (wrapper.classList.contains('embed-responsive')) {
            lastMovedChild = cleanResponsiveWrapper(wrapper, ['iframe']);
        }

        if (lastMovedChild) {
            editor.editor.selection.select(lastMovedChild, true);
            editor.editor.selection.collapse();
        }
    }
}

export function processNewBlock(newBlock: Element, editor: Editor) {
    // when the user presses the enter key

    if (newBlock.tagName.toLowerCase() === 'div') {
        // if tinyMCE created an empty div we need to replace it with a paragraph

        const paragraph = document.createElement('p');
        paragraph.appendChild(document.createElement('br'));
        newBlock.replaceWith(paragraph);
        editor.editor.selection.select(paragraph, true);
    }

    processNodeChange(newBlock.parentElement, editor);
}

/**
 * The responsive element fills the entire available width.
 * This function is useful to move unwanted nodes outside of the responsive element's container.
 */
export function cleanResponsiveWrapper(wrapper: Element, allowedTagNames: string[]) {
    if (!wrapper.children.length) {
        // there is no HTML element inside, so we need to remove the wrapper
        wrapper.remove();
        return null;
    }

    if (wrapper.childNodes.length === 1) {
        // there is one node which is an HTML element so it looks like everything is OK
        return null;
    }

    // if there are nodes except the allowed element we need to move them outside
    let elementFound = false;
    let lastChild: Node = null;
    const allowedElements = allowedTagNames.map((name) => wrapper.getElementsByTagName(name)[0]);

    Array.from(wrapper.childNodes).forEach((child) => {
        if (child.textContent === '\uFEFF') {
            // in tinyMCE this is an empty space for cursor
            return;
        }

        if (!elementFound && allowedElements.some((element) => child.contains(element))) {
            elementFound = true;
            return;
        }

        wrapper.parentNode.insertBefore(child, elementFound ? wrapper.nextSibling : wrapper);
        lastChild = child;
    });

    return lastChild;
}

export function addGoogleMapButton(editor: Editor) {
    editor.editor.ui.registry.addButton('google_map', {
        icon: 'language',
        onAction: () => {
            editor.editor.windowManager.open<{ mapId: string; height: string }>({
                title: 'Google Map',
                body: {
                    type: 'panel',
                    items: [
                        {
                            type: 'input',
                            inputMode: 'numeric',
                            placeholder: '1',
                            name: 'mapId',
                            label: 'Map ID',
                        },
                        {
                            type: 'input',
                            inputMode: 'numeric',
                            placeholder: '400',
                            name: 'height',
                            label: 'Map height',
                        },
                    ],
                },
                buttons: [
                    { text: 'Close', type: 'cancel' },
                    { text: 'Insert', type: 'submit', primary: true },
                ],
                onSubmit: (api) => {
                    const mapId = Math.max(parseInt(api.getData().mapId), 0) || 1;
                    const height = Math.max(parseInt(api.getData().height), 0) || 400;

                    if (editor.editor.selection.getRng().startOffset > 0) {
                        editor.editor.execCommand('mceInsertNewLine');
                    }

                    editor.editor.insertContent(
                        '<div class="google-map-markers" style="height:' +
                            `${height}px; background-color: #eee;" data-map-id="${mapId}">` +
                            'Google Map loading...</div>'
                    );

                    api.close();
                },
            });
        },
    });
}
